<template>
  <div class="plenary-panel">
    <h2 class="-large-title">Plenary session</h2>
    <div class="instruction">
      <p>Scan the QR code on the right with your mobile phone or enter the link in your browser to enter the session.</p>
    </div>
    <!-- <img src="@/assets/background-scan.svg" class="background" alt="Scan code" /> -->
    <div class="code">
      <qrcode :value="qrLink" :options="qrOptions"></qrcode>
    </div>
  </div>
</template>

<script>
// import VueQrcode from '@chenfengyuan/vue-qrcode'
export default {
  name: "PlenaryCover",
  components: {
    // VueQrcode,
  },
  data () {
    return {
      qrOptions: {
        width: 325,
        color: {
          dark:"#0728D1",
          light:"#fff"
        }
      }
    }
  },
  mounted () {
  },
  computed: {
    baseUrl () {
      return this.$store.state.baseUrl
    },
    qrLink () {
      // return this.baseUrl + this.$route.fullPath + "?scanned=1";
      return this.baseUrl + "/trainee/scenario/12/playlist/a1?scanned=1";
    }
  }
}
</script>

<style lang="scss" scoped>
  .plenary-panel {
    height: 100%;
    background: white;
    display: grid;
    grid-template-areas: 
      "title ."
      "image code";
    grid-template-columns: 2fr 1.2fr;
    grid-template-rows: min-content 500px;

    @media all and (max-width: 929px) {
      padding: 0 20px;
    }
  }

  h2 {
    grid-area: title;
  }
  .code {
    grid-area: code;
    height: 100%;
    margin-top: -27px;
  }
  .instruction {
    grid-area: image;
    background-image: url('~@/assets/background-scan.svg');
    background-size: 100% auto;
    background-repeat: no-repeat;
    height: 100%;
  }
  p {
    font-size: 20px;
    color: var(--primary);
    max-width: 400px;
  }
  i {
    font-size: 113px;
  }
</style>